import InfoIcon from '@mui/icons-material/Info';

export function InfoSolid() {
    return <InfoIcon sx={{ color: '#7FAAE6' }} />;
}

export function InfoSolidError() {
    return <InfoIcon sx={{ color: '#962C27' }} />;
}
